import React, { useEffect } from "react";
/** Components Import */
import { Modal } from "react-bootstrap";
import { ClimbingBoxLoader, ClockLoader } from "react-spinners";

function Loading({
  modalClassName = "",
  className = "",
  // size = 15,
  size = 100,
  color = "#ffffff",
  show = false,
  // setShow = (e) => {},
  // duration = 3000,
}) {
  // useEffect(() => {
  //   if (show) {
  //     window.setTimeout(() => setShow(false), [duration]);
  //   }
  // }, [show]);

  return (
    <Modal
      className={modalClassName}
      contentClassName="loading-modal-wrap"
      centered
      backdrop="static"
      show={show}
    >
      {/* <ClimbingBoxLoader className={className} size={size} color={color} /> */}
      <ClockLoader className={className} size={size} color={color} />
    </Modal>
  );
}

export default Loading;
